import monitorRouterPaths from './monitorRouterPaths';

export default monitorRouterPaths;
